
import { Layout } from 'ant-design-vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'page-content',
  components: {
    'a-layout-content': Layout.Content,
  },
  props: {
    transparent: { type: Boolean, default: false },
  },
});
